import { theme as chakraTheme } from "@chakra-ui/react";

export const fonts = {
  ...chakraTheme.fonts,
  body: `Inter, sans-serif`,
  heading: `Inter, sans-serif`,
};
